import {
  postMonotoringAndEvaluationModule,
  setMonotoringAndEvaluationModule,
} from '../../config/apiSinToken'

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: INSERT Monoting and Evaluation Answer
 * FECHA: 20-01-2023
 */
export const insertMonitoringAndEvaluationQuestionnaireAnswers = async (
  form,
) => {
  const data = await postMonotoringAndEvaluationModule(
    `api/v1/MonitoringAndEvaluationQuestionnaireAnswers/Insert`,
    form,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Description: Actualizar estado del formulario
 * Fecha: 11/10/2023
 */
export const UpdateStatusFormMonitoringAndEvaluation = async (
  idForm,
  idB2C,
  idFormStatus,
  Observations,
) => {
  const data = await postMonotoringAndEvaluationModule(
    `api/v1/MonitoringAndEvaluationQuestionnaireAnswers/Form/Status?idForm=${idForm}&idFormStatus=${idFormStatus}&UserB2C=${idB2C}&Observations=${Observations}`,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: INSERT Monoting and Evaluation Inform Answer
 * FECHA: 06-12-2023
 */
export const insertReportAnswers = async (form) => {
  const data = await setMonotoringAndEvaluationModule(
    `api/v1/ReportAnswers/Insert`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Upload Report Monitoring
 * FECHA: 6-2-2024
 */
export const uploadReportMonitoring = async (idForm, idB2C, idHistory) => {
  const data = await postMonotoringAndEvaluationModule(
    `api/v1/ReportMonitoringEvaluation/MidTermReport?IdForm=${idForm}&UserB2C=${idB2C}&IdFormHistory=${idHistory}`,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Upload Report Cuestionary
 * FECHA: 6-2-2024
 */
export const uploadReportCuestionary = async (idForm, idB2C, idHistory) => {
  const data = await postMonotoringAndEvaluationModule(
    `api/v1/ReportMonitoringEvaluation/ReportQuestionario?IdForm=${idForm}&UserB2C=${idB2C}&IdFormHistory=${idHistory}`,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Upload Report Final TErm
 * FECHA: 14-2-2024
 */
export const uploadReportMonitoringFinalTerm = async (
  idForm,
  idB2C,
  idHistory,
) => {
  const data = await postMonotoringAndEvaluationModule(
    `api/v1/ReportMonitoringEvaluation/FinalTermReport?IdForm=${idForm}&UserB2C=${idB2C}&IdFormHistory=${idHistory}`,
  )
  return data
}
